import React from "react";
import { Link } from "react-router-dom";
import { Collapse } from "@mui/material";
import pathnames from "../../../constants/pathnames";

const isChildActive = (child, pathname) => {
  if (!pathname || !child?.path) return false;
  if (pathname === child.path) return true;
  if (
    child.path === pathnames.PROMO_CODES_OVERVIEW &&
    (pathname === pathnames.PROMO_CODES || pathname === pathnames.PROMO_CODES_CREATE)
  ) {
    return true;
  }
  if (child.matches?.some((path) => pathname === path || pathname.startsWith(path + "/"))) return true;
  return child.path !== "/" && pathname.startsWith(child.path + "/");
};

// A child's path can be the prefix of a sibling's, so only the most specific match is highlighted
const getActiveChild = (item, pathname) =>
  item.children
    ?.filter((child) => isChildActive(child, pathname))
    .reduce((best, child) => (!best || child.path.length > best.path.length ? child : best), null);

export const isGroupActive = (item, pathname) =>
  Boolean(
    pathname &&
      ((item?.path &&
        item.path !== "/" &&
        (pathname === item.path || pathname.startsWith(item.path + "/"))) ||
        item?.children?.some((child) => isChildActive(child, pathname)))
  );

const SidebarCollapsibleItem = ({ item, pathname, isOpen, onToggle, onNavigate }) => {
  const isParentActive = isGroupActive(item, pathname);
  const activeChild = getActiveChild(item, pathname);

  const Icon = item.Icon;
  const submenuId = `sidebar-submenu-${item.name.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={submenuId}
        className={`sidebar-nav-item${isParentActive ? " is-open-parent" : ""}`}
      >
        {Icon && (
          <span className="sidebar-nav-icon">
            <Icon />
          </span>
        )}
        <span className="sidebar-nav-label">{item?.name}</span>
        <span className={`sidebar-nav-chevron${isOpen ? " is-open" : ""}`} aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>

      <Collapse in={isOpen} timeout={220}>
        <div id={submenuId} className="sidebar-nav-submenu">
          {item.children?.map((child) => {
            const active = child === activeChild;
            return (
              <Link
                key={child.path}
                to={child.path}
                onClick={onNavigate}
                aria-current={active ? "page" : undefined}
                className={`sidebar-nav-subitem${active ? " is-active" : ""}`}
              >
                {child.name}
              </Link>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
};

export default SidebarCollapsibleItem;
